import { FunctionComponent } from 'react';
import { useRouter } from 'next/router';

import { Routes } from 'types/routes';

import { parseToQueryString } from 'utils/querystring';
import { withVariables } from 'utils/string';

import Pagination from 'components/layout/Pagination';
import { Positions, Sizes } from 'components/layout/Spinner';
import Spinner from 'components/layout/Spinner/component';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageHomeSectionResultsList: FunctionComponent<Props> = ({
    translations: { allCompanies, companiesResult, empty, offers },
    companies,
    onChangePage,
    searchParams,
}) => {
    const router = useRouter();
    const areCompanies = Array.isArray(companies?.elements) && companies?.elements?.length > 0;
    const isLoading = companies?.isLoading;
    const areResults = searchParams.search.getValue() || searchParams.category.getValue().length > 0;

    const translationsOffersCount = (count: number): string => {
        const countToString = count?.toString();

        return count > 4
            ? offers?.fromFive?.replace('{value}', countToString)
            : count > 1
                ? offers?.twoToFour?.replace('{value}', countToString)
                : offers?.one?.replace('{value}', countToString);
    };

    return (
        <StyledComponent className="public-page-company-sites-section-results-list">
            <section className="results-wrapper">
                <header className="results-header">
                    { areCompanies && !isLoading && !areResults && (
                        <h2 className="results-title">{allCompanies}</h2>
                    )}
                    {areCompanies && areResults && (
                        <h2 className="results-title">{companiesResult}</h2>
                    )}
                </header>
                <div className="list">
                    <div className="results-list">
                        { areCompanies && companies?.elements?.map(({ id, company, jobCategory, logo, bgImage }) => (
                            <a
                                key={id}
                                className="result-wrapper"
                                href={withVariables(Routes.PublicCompanySite, { slug: company?.slug })}
                            >
                                <div className='result-image-box'>
                                    <img
                                        className="result-image"
                                        src={bgImage?.imageUrl || null}
                                        alt=""
                                    />
                                </div>
                                <div className="result-details-cols">
                                    <div className="result-details-col">
                                        <h3 className="company-name">
                                            {company?.shortName || company?.name}
                                        </h3>
                                        <p className="company-category">{jobCategory?.name}</p>

                                        { company?.jobCount > 0 && (
                                            <p className="company-jobs">{ translationsOffersCount(company?.jobCount) }</p>
                                        )}
                                    </div>
                                    <div className="result-logo-col">
                                        <img
                                            className="result-logo"
                                            src={logo?.imageUrl}
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </a>
                        ))}
                        {isLoading && (
                            <Spinner
                                position={Positions.Relative}
                                size={Sizes.Large}
                            />
                        )}
                    </div>
                    { !areCompanies && !isLoading && (
                        <div className="empty">
                            <div
                                className="empty-title"
                                dangerouslySetInnerHTML={{ __html: empty?.title }}
                            />
                            <div
                                className="empty-subtitle"
                                dangerouslySetInnerHTML={{ __html: empty?.subtitle }}
                            />
                        </div>
                    )}
                </div>
                { areCompanies && (
                    <Pagination
                        currentPage={companies.meta.currentPage}
                        lastPage={companies.meta.lastPage}

                        hrefBuilder={(currentPage) => {
                            const urlSearchParams = new URLSearchParams;
                            const { ...queryParams }: any = router.query;

                            Object.keys(router.query)
                                .map( key => urlSearchParams.set(key, queryParams[ key ]) );

                            if (currentPage == 1) urlSearchParams.delete('page');
                            else urlSearchParams.set('page', currentPage.toString() );
                            return '/baza-pracodawcow/?' + urlSearchParams.toString();
                        }}

                        onPageChange={(nextPage: number) => {
                            if (nextPage === companies?.meta?.currentPage) return;
                            onChangePage(nextPage);
                        }}

                    />
                )}
            </section>
        </StyledComponent>
    );
};

export default PublicPageHomeSectionResultsList;
